module.exports = __webpack_public_path__ + "assets/img/kefu1.3d64106f.png";